import { styled } from '@mui/material/styles';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { hexToRgba } from '../utils/colors';
export var StyledCollapse = styled(Collapse)(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
    lineHeight = _ref.lineHeight,
    open = _ref.in,
    theme = _ref.theme;
  return {
    position: 'relative',
    '&:after, &:before': {
      content: "' '",
      display: 'block',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      width: '100%',
      opacity: open ? 0 : 1,
      transiton: 0.5
    },
    '&:after': {
      height: open ? 0 : '66%',
      background: "linear-gradient(0deg, " + hexToRgba(backgroundColor, 1) + " 0%, " + hexToRgba(backgroundColor, 0) + " 100%)"
    },
    '&:before': {
      height: lineHeight || 0,
      background: "linear-gradient(90deg, " + hexToRgba(backgroundColor, 0) + " 0%, " + hexToRgba(backgroundColor, 1) + " 100%)"
    }
  };
});
export var StyledArrowDownIcon = styled(KeyboardArrowDownIcon)({
  transform: function transform(_ref2) {
    var open = _ref2.open;
    return open ? 'rotate(180deg)' : null;
  }
});
export var StyledButtonWrapper = styled('div')(function (_ref3) {
  var open = _ref3.open,
    lineHeight = _ref3.lineHeight;
  return {
    '& .MuiButton-root': {
      textTransform: 'none',
      top: !open && lineHeight > 0 ? 0 - lineHeight / 2 : 0,
      backgroundColor: '#fff'
    }
  };
});